interface StepperProps {
  current: number;
  steps: string[];
}

export default function Stepper({ current, steps }: StepperProps) {
  return (
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-3 md:gap-x-3">
      {steps.map((label, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <li key={label} className="flex items-center gap-2 md:gap-3">
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs font-medium transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : done
                    ? "border-primary-300 bg-primary-100 text-primary-700"
                    : "border-background-300 bg-background-50 text-foreground-500"
              }`}
            >
              {done ? <i className="ri-check-line text-base" /> : index + 1}
            </span>
            <span
              className={`whitespace-nowrap text-xs md:text-sm ${
                active ? "font-medium text-foreground-900" : "text-foreground-600"
              }`}
            >
              {label}
            </span>
            {index < steps.length - 1 ? (
              <span className="hidden h-px w-8 bg-background-300 md:block lg:w-12" />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}